import { render, staticRenderFns } from "./PaymentUploadExcelFile.vue?vue&type=template&id=67cc10ab&scoped=true"
import script from "./PaymentUploadExcelFile.vue?vue&type=script&lang=js"
export * from "./PaymentUploadExcelFile.vue?vue&type=script&lang=js"
import style0 from "./PaymentUploadExcelFile.vue?vue&type=style&index=0&id=67cc10ab&lang=css"
import style1 from "./PaymentUploadExcelFile.vue?vue&type=style&index=1&id=67cc10ab&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cc10ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67cc10ab')) {
      api.createRecord('67cc10ab', component.options)
    } else {
      api.reload('67cc10ab', component.options)
    }
    module.hot.accept("./PaymentUploadExcelFile.vue?vue&type=template&id=67cc10ab&scoped=true", function () {
      api.rerender('67cc10ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/components/file/PaymentUploadExcelFile.vue"
export default component.exports